export default "__VITE_ASSET__B9L5C60y__"